export default "__VITE_ASSET__CDGajFzF__"